import { render } from "./RppLtl.vue?vue&type=template&id=24f6b50a&scoped=true&ts=true"
import script from "./RppLtl.vue?vue&type=script&lang=ts"
export * from "./RppLtl.vue?vue&type=script&lang=ts"

import "./RppLtl.vue?vue&type=style&index=0&id=24f6b50a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f6b50a"]])

export default __exports__